import EditableText from "./editable_text";
import { TextField } from "@mui/material";
import styles from "../crf_builder.module.css";

function VariableName(props) {
  const { onChange, value, field_name } = props;
  return (
    <div className={styles.variable_name_row}>
      <div>{field_name}</div>
      <EditableText text={value} onChange={onChange} width={100} placeholder="placeholder" />
    </div>
  );
}

const sx = {
  marginLeft: "4px",
  marginTop: "10px",
  "& .MuiInputBase-input": {
    width: "auto",
    minWidth: "140px",
    maxWidth: "200px",

    fieldSizing: "content",
  },
};

const onKeyDown = (key) => {
  if (key.keyCode === 13) {
    key.target.blur();
  }
};

export default function Data(props) {
  const { field, changeVariableName } = props;
  return (
    <div className={styles.data_entry}>
      <TextField
        value={field.value_name || ""}
        label="value key"
        type="text"
        size="small"
        onChange={(e) => changeVariableName(field.id, "value_name", e.target.value)}
        sx={sx}
        onKeyDown={onKeyDown}
      />

      {["datetime", "weight", "blood_pressure", "blood_test_result", "blood_pressure_date_time", "radio"].includes(
        field.type,
      ) ? (
        <TextField
          value={field.value2_name || ""}
          label="value2 key"
          type="text"
          size="small"
          onChange={(e) => changeVariableName(field.id, "value2_name", e.target.value)}
          sx={sx}
          onKeyDown={onKeyDown}
        />
      ) : null}
      {["blood_test_result", "weight", "blood_pressure_date_time"].includes(field.type) ? (
        <TextField
          value={field.value3_name || ""}
          label="value3 key"
          type="text"
          size="small"
          onChange={(e) => changeVariableName(field.id, "value3_name", e.target.value)}
          sx={sx}
          onKeyDown={onKeyDown}
        />
      ) : null}
      {["blood_test_result", "blood_pressure_date_time"].includes(field.type) ? (
        <TextField
          value={field.value4_name || ""}
          label="value4 key"
          type="text"
          size="small"
          onChange={(e) => changeVariableName(field.id, "value4_name", e.target.value)}
          sx={sx}
          onKeyDown={onKeyDown}
        />
      ) : null}
      {["blood_pressure_date_time"].includes(field.type) ? (
        <TextField
          value={field.value5_name || ""}
          label="value5 key"
          type="text"
          size="small"
          onChange={(e) => changeVariableName(field.id, "value5_name", e.target.value)}
          sx={sx}
          onKeyDown={onKeyDown}
        />
      ) : null}
    </div>
  );
}
